import { CommonModule } from "@angular/common";
import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	Output,
} from "@angular/core";

/**
 * Radio individual del design-system `.ds`, sin Material. Presentacional (no CVA): pensado para
 * selección de fila en tablas/listas (los diálogos de asociar). El contenedor gestiona la
 * selección y pasa `[checked]`; al activarse emite `(selected)`. Sustituye a `mat-radio-button`.
 */
@Component({
	selector: "app-ds-radio",
	standalone: true,
	imports: [CommonModule],
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `
		<label class="ds-radio" [class.disabled]="disabled">
			<input
				type="radio"
				[checked]="checked"
				[disabled]="disabled"
				(change)="onSelect()"
			/>
			<span class="ds-radio-dot" aria-hidden="true"></span>
			<span class="ds-radio-label" *ngIf="label">{{ label }}</span>
		</label>
	`,
	styles: [
		`
			.ds-radio {
				display: inline-flex;
				align-items: center;
				gap: 8px;
				cursor: pointer;
			}
			.ds-radio.disabled {
				cursor: not-allowed;
				opacity: 0.6;
			}
			.ds-radio input {
				position: absolute;
				opacity: 0;
				width: 0;
				height: 0;
			}
			.ds-radio-dot {
				flex: none;
				width: 18px;
				height: 18px;
				border-radius: 50%;
				border: 2px solid var(--line);
				background: var(--paper);
				position: relative;
				transition:
					border-color 0.15s,
					box-shadow 0.15s;
			}
			.ds-radio input:checked + .ds-radio-dot {
				border-color: var(--accent);
			}
			.ds-radio input:checked + .ds-radio-dot::after {
				content: "";
				position: absolute;
				inset: 3px;
				border-radius: 50%;
				background: var(--accent);
			}
			.ds-radio input:focus-visible + .ds-radio-dot {
				box-shadow: 0 0 0 3px var(--accent-soft);
			}
			.ds-radio-label {
				font-size: 14px;
				color: var(--ink);
			}
		`,
	],
})
export class DsRadioComponent {
	@Input() checked = false;
	@Input() disabled = false;
	@Input() label = "";
	@Output() selected = new EventEmitter<void>();

	onSelect(): void {
		if (!this.disabled) {
			this.selected.emit();
		}
	}
}
